import type { PollService } from "@busbud/core-types";

/**
 * Get the localized price based on the given parameters.
 * This support both UDM V3 and V4 price groups.
 */
export interface LocalizedPriceParams {
  base: number;
  supplier_fees: number;
  busbud_fees: number;
  taxes: number;
}

export const normalizedLocalizedPrice = (
  price:
    | PollService.API.PublicPriceGroupV4["fixed_prices"]
    | PollService.API.PublicPriceGroup["prices"]
) => {
  if (price.hasOwnProperty("breakdown")) {
    return (price as PollService.API.PublicPriceGroup["prices"]).breakdown;
  }

  const _price = price as PollService.API.PublicPriceGroupV4["fixed_prices"];

  return {
    base: _price.base,
    supplier_fees: _price.supplier_fees,
    busbud_fees: _price.busbud_fees,
    taxes: _price.taxes
  };
};
